export const Prices = [
    {
      _id: 0,
      name: "$0 to 39",
      array: [0, 39],
    },
    {
      _id: 2,
      name: "$40 to 79",
      array: [40, 79],
    },
    {
      _id: 4,
      name: "$80 to 99",
      array: [80, 99],
    },
    {
      _id: 5,
      name: "$100 or more",
      array: [100, 9999],
    },
  ];